import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { FormLogoComponent } from './form-logo.component';

@NgModule({
  imports: [CommonModule, UiModule, TrackingModule],
  declarations: [FormLogoComponent],
  exports: [FormLogoComponent],
})
export class FormLogoModule {}
